import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getLogger } from '@alilc/lowcode-utils';
import { invariant } from '../utils';
export var LowCodePluginRuntime = /*#__PURE__*/function () {
  function LowCodePluginRuntime(pluginName, manager, config, meta) {
    this.config = void 0;
    this.logger = void 0;
    this.manager = void 0;
    this._inited = void 0;
    this.pluginName = void 0;
    this.meta = void 0;
    /**
     * 标识插件状态，是否被 disabled
     */
    this._disabled = void 0;
    this.manager = manager;
    this.config = config;
    this.pluginName = pluginName;
    this.meta = meta;
    this.logger = getLogger({
      level: 'warn',
      bizName: "plugin:" + pluginName
    });
  }
  var _proto = LowCodePluginRuntime.prototype;
  _proto.isInited = function isInited() {
    return this._inited;
  };
  _proto.init = /*#__PURE__*/function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(forceInit) {
      var _this$config$init;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(this._inited && !forceInit)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            this.logger.log('method init called');
            _context.next = 5;
            return (_this$config$init = this.config.init) === null || _this$config$init === void 0 ? void 0 : _this$config$init.call(undefined);
          case 5:
            this._inited = true;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function init(_x) {
      return _init.apply(this, arguments);
    }
    return init;
  }();
  _proto.destroy = /*#__PURE__*/function () {
    var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$config, _this$config$destroy;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (this._inited) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            this.logger.log('method destroy called');
            _context2.next = 5;
            return (_this$config = this.config) === null || _this$config === void 0 ? void 0 : (_this$config$destroy = _this$config.destroy) === null || _this$config$destroy === void 0 ? void 0 : _this$config$destroy.call(undefined);
          case 5:
            this._inited = false;
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function destroy() {
      return _destroy.apply(this, arguments);
    }
    return destroy;
  }();
  _proto.setDisabled = function setDisabled(flag) {
    if (flag === void 0) {
      flag = true;
    }
    this._disabled = flag;
  };
  _proto.toProxy = function toProxy() {
    var _this$config$exports, _this$config2;
    invariant(this._inited, 'Could not call toProxy before init');
    var exports = (_this$config$exports = (_this$config2 = this.config).exports) === null || _this$config$exports === void 0 ? void 0 : _this$config$exports.call(_this$config2);
    return new Proxy(this, {
      get: function get(target, prop, receiver) {
        if ({}.hasOwnProperty.call(exports, prop)) {
          return exports === null || exports === void 0 ? void 0 : exports[prop];
        }
        return Reflect.get(target, prop, receiver);
      }
    });
  };
  _proto.dispose = /*#__PURE__*/function () {
    var _dispose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.manager["delete"](this.name);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function dispose() {
      return _dispose.apply(this, arguments);
    }
    return dispose;
  }();
  _createClass(LowCodePluginRuntime, [{
    key: "name",
    get: function get() {
      return this.pluginName;
    }
  }, {
    key: "dep",
    get: function get() {
      if (typeof this.meta.dependencies === 'string') {
        return [this.meta.dependencies];
      }
      // compat legacy way to declare dependencies
      var legacyDepValue = this.config.dep;
      if (typeof legacyDepValue === 'string') {
        return [legacyDepValue];
      }
      return this.meta.dependencies || legacyDepValue || [];
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._disabled;
    }
  }]);
  return LowCodePluginRuntime;
}();